export default __webpack_public_path__ + "static/media/Ellipse13.00c7612f.png";